import { useEffect, useRef } from 'react'

function isMobile() {
  const userAgent = navigator.userAgent || navigator.vendor
  const isMobileOrTablet =
    /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|iPad/i.test(
      userAgent,
    ) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  return isMobileOrTablet
}

const useSpeechToText = () => {
  const isListening = useRef<boolean>(false)
  const userTranscript = useRef<string>('')

  const recongnitionRef = useRef<SpeechRecognition | null>(null)
  const myFluency = useRef(5) // Initialize fluency, you can adjust it based on your needs
  const t0 = useRef(0)
  const t1 = useRef(0)
  const pauseThreshold = useRef(0)

  useEffect(() => {
    const SpeechRecognition = window.webkitSpeechRecognition
    recongnitionRef.current = new SpeechRecognition()
    console.log('speech init')
    if (recongnitionRef.current) {
      recongnitionRef.current.lang = 'en-US'
      recongnitionRef.current.continuous = true
      recongnitionRef.current.interimResults = true
      recongnitionRef.current.onresult = (event: any) => {
        console.log('onresult')
        userTranscript.current = ''
        for (let i = event.resultIndex; i < event.results.length; i++) {
          if (event.results[i].isFinal)
            userTranscript.current += event.results[i][0].transcript
          else userTranscript.current += event.results[i][0].transcript
        }
        console.log(userTranscript.current)
        console.log('isMobile', isMobile())

        const now = isMobile() ? Date.now() : performance.now()
        console.log('now', now)

        if (t0.current === 0) {
          // First recognized speech, set the initial timestamp
          t0.current = now
          t1.current = now
        } else {
          // Calculate the pause duration
          const pauseDuration = now - t1.current
          console.log('pauseDuration', pauseDuration)

          // Apply fluency calculation based on the pause duration
          const factor = isMobile() ? 1.5 : 1
          const fluencyConfig = [
            { threshold: 5000 * factor, reduction: myFluency.current },
            { threshold: 750 * factor, reduction: 1 },
            { threshold: 691 * factor, reduction: 0.5 },
            { threshold: 651 * factor, reduction: 0.4 },
            { threshold: 591 * factor, reduction: 0.3 },
            { threshold: 551 * factor, reduction: 0.2 },
            { threshold: 450 * factor, reduction: 0.1 },
          ]

          const config = fluencyConfig.find(
            (config) => pauseDuration >= config.threshold,
          )
          if (config) {
            if (config.threshold === (isMobile() ? 3000 : 5000)) {
              myFluency.current = 0 // Set fluency to 0 for long pauses
              pauseThreshold.current = 1
            } else {
              myFluency.current = Math.max(
                0,
                myFluency.current - config.reduction,
              )
            }
          }

          console.log('myFluency', myFluency.current)

          // Update the timestamp for the next pause
          t1.current = now
        }
      }
      recongnitionRef.current.onerror = (event: any) => {
        console.log(event.error)
      }
      recongnitionRef.current.onend = () => {
        console.log('onend')
        isListening.current = false
      }
    }

    return () => {
      recongnitionRef.current?.stop()
    }
  }, [])

  const startListening = () => {
    if (recongnitionRef.current && !isListening.current) {
      recongnitionRef.current.start()
      isListening.current = true
    }
  }

  const stopListening = () => {
    if (recongnitionRef.current && isListening.current) {
      recongnitionRef.current.stop()
      isListening.current = false
    }
  }

  return {
    isListening,
    userTranscript,
    myFluency,
    pauseThresold: pauseThreshold,
    startListening,
    stopListening,
  }
}

export default useSpeechToText
